function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.571 2a3.569 3.569 0 0 1 3.489 2.857H18c1.182 0 2.143.961 2.143 2.143A2.145 2.145 0 0 1 18 9.143v10.714A2.145 2.145 0 0 1 15.857 22H7.286a2.145 2.145 0 0 1-2.143-2.143V9.143A2.145 2.145 0 0 1 3 7c0-1.182.961-2.143 2.143-2.143h2.93A3.577 3.577 0 0 1 11.57 2zm5 7.143h-10v10.714c0 .394.32.714.715.714h8.571c.394 0 .714-.32.714-.714V9.143zM9.43 11.286c.394 0 .714.32.714.714v7.143a.714.714 0 1 1-1.429 0V12c0-.395.32-.714.715-.714zm4.285 0c.395 0 .715.32.715.714v7.143a.714.714 0 1 1-1.429 0V12c0-.395.32-.714.714-.714zm4.286-5H5.143a.715.715 0 0 0 0 1.428H18a.715.715 0 0 0 0-1.428zm-6.429-2.857c-.93 0-1.725.597-2.02 1.428h4.041a2.147 2.147 0 0 0-2.02-1.428z",
  fill: "#919191",
  fillRule: "nonzero",
  stroke: "#919191",
  strokeWidth: 0.5
});

var SvgIconSil = function SvgIconSil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-sil.9fe12894.svg";
export { ForwardRef as ReactComponent };